import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import { IReportingPeriodItem } from "../../model/report/ReportingPeriodItem";
import Application from "../../Application";
import { IApplicantReport } from "../../model/report/ApplicantReport";
import GetDataReport5Interactor from "../../interactor/report/GetDataReport5Interactor";

export interface TReport5Presenter extends TLoadingAwarePresenter {
  report5ReportingPeriodList: IReportingPeriodItem[];
  report5CurrentReportingPeriod?: IReportingPeriodItem;
  report5?: IApplicantReport[];
}

export interface IReport5Presenter extends TReport5Presenter, TPresentable {
  loadReportingPeriodList(reportingPeriodList: IReportingPeriodItem[]): void;
  onChangeReportingPeriod(reportingPeriodId: number): void;
  getPDFReport5(): Promise<any>;
}

const defaultState: TReport5Presenter = {
  report5ReportingPeriodList: []
};

const Report5Presenter = withStore<IReport5Presenter, TReport5Presenter>(
  ({ application, store, loader, translate }): IReport5Presenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TReport5Presenter>();

    const loadReportingPeriodList = (
      report5ReportingPeriodList: IReportingPeriodItem[]
    ) => {
      _store.update({
        report5ReportingPeriodList
      });
    };

    const onChangeReportingPeriod = (reportingPeriodId: number) => {
      const reportingPeriodList = _store.getState<TReport5Presenter>()
        .report5ReportingPeriodList;
      const report5CurrentReportingPeriod = reportingPeriodList.find(
        reportingPeriod => reportingPeriod.id === reportingPeriodId
      );
      _store.update({
        report5CurrentReportingPeriod,
        report5: undefined
      });
    };

    const getPDFReport5 = async () => {
      const report5CurrentReportingPeriod = _store.getState<TReport5Presenter>()
        .report5CurrentReportingPeriod;
      loader.start("report5Loader");
      const report5 =
        report5CurrentReportingPeriod &&
        (await application.container
          .resolve<GetDataReport5Interactor>("getDataReport5")
          .execute(report5CurrentReportingPeriod.id));
      _store.update({
        report5
      });
      loader.stop("report5Loader");
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadReportingPeriodList,
      onChangeReportingPeriod,
      getPDFReport5
    };
  },
  defaultState
);

export default Report5Presenter;
